import {FC} from 'react'
import {gql} from '@apollo/client'
import {useController, useFormContext} from 'react-hook-form'
import Select from 'react-select'
import {Body, BodyItems, Header, Row} from 'components/SearchForm/AdditionalSearchField'
import {useQuery} from 'hooks/graphql'
import {Option, withNullOpt, toOpts} from 'libs/options'
import styles from './Prefectures.scss'

const PREFECTURES = gql`
  query countries {
    client {
      employeeConnections {
        prefectures {
          id
          name
        }
      }
    }
  }
`

interface CountriesQueryResult {
  client: {
    employeeConnections: {
      prefectures: {
        id: string
        name: string
      }[]
    }
  }
}

export const Prefectures: FC = () => {
  const {data} = useQuery<CountriesQueryResult>(PREFECTURES, {fetchPolicy: 'cache-and-network'})
  const prefectures = data?.client?.employeeConnections?.prefectures || []

  return (
    <Row>
      <Header>都道府県</Header>
      <Body>
        <BodyItems>
          <div className={styles.box}>
            <PrefectureSelect name="prefectureIds" options={withNullOpt(toOpts(prefectures))} />
          </div>
        </BodyItems>
      </Body>
    </Row>
  )
}

interface PrefectureSelectProps {
  name: string
  options: Option[]
}

const PrefectureSelect: FC<PrefectureSelectProps> = ({name, options}) => {
  const {control} = useFormContext()
  const {field} = useController({control, name, shouldUnregister: true})

  return (
    <Select
      multi
      closeOnSelect={false}
      onChange={(value) => {
        if (!Array.isArray(value)) {
          return
        }
        const values = value.map((v) => v.value).filter((v) => v !== undefined)
        field.onChange(values)
        field.onBlur()
      }}
      options={options}
      value={field.value}
      placeholder="都道府県選択"
    />
  )
}
